import { render, staticRenderFns } from "./BookingAmount.vue?vue&type=template&id=0802f529"
import script from "./BookingAmount.vue?vue&type=script&lang=ts"
export * from "./BookingAmount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports